import { ATDateManager } from "../third-party/com-aurvan-atkit-reactjs/src/at-date-manager";

class SubscriptionBenefit {
	maximumDiskSpaceInBytes = 0;
}


export { SubscriptionBenefit };
